export default "__VITE_ASSET__3b7ae59c__"